import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'user-input-area',
  templateUrl: './user-input-area.component.html',
  styleUrls: ['./user-input-area.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class UserInputAreaComponent implements OnInit {
  @Input() placeholderText: string = 'Enter text here';
  @Input() rows: number = 5;
  @Input() autoFocus: boolean = true;
  @Input() ariaLabel: string | null = null;
  @Input() ariaLabelledBy: string | null = null;
  @Input() ariaDescribedBy: string | null = null;
  @Input() ariaInvalid: boolean = false;
  @Input() ariaRequired: boolean = false;
  @Input() inputId?: string;
  inputValue: string = '';
  @Output() feedbackTextArea = new EventEmitter<string>();
  @ViewChild('textareaEl') textareaEl!: ElementRef<HTMLTextAreaElement>;
  constructor() {}

  ngOnInit(): void {}

  onValueChange(newValue: string): void {
    this.inputValue = newValue;
    this.feedbackTextArea.emit(newValue);
  }

  focus(): void {
    this.textareaEl?.nativeElement?.focus();
  }
}
